/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useContext, useState, useEffect } from "react";
import { VscListFilter } from "react-icons/vsc";
import { toast } from "react-toastify";

import Footer from "../../components/Footer";
import Sidebar from "../../components/Sidebar";
import {
	Apresentation,
	ContentMain,
	DefaultButton,
	Error,
	MyTable,
	MyTableBody,
	MyTableHead,
	MyTableTR,
	Page,
	ScreenView,
	SubPageMain,
} from "../../style/default";
import { Skeleton } from "../../components/Skeleton/table";
import {
	MyHorizontalScrollView,
	ContainerCheckbox,
	StickyButtonFooter,
} from "./style";
import { authApi } from "../../services/api";
import { TOASTIFY_OPTIONS } from "../../style/global";
import NumberOfficialMonitorFilter from "./modal-filter";
import { NumberOfficialMonitorContext } from "../../context/numberOfficialMonitorData";
import { Loading } from "../../components/Loading";
import MyTooltip from "../../components/Tooltip";
import { FaLink } from "react-icons/fa";
import { ModalContext } from "../../context/modal";
import { LinkBot } from "./link-bot";

function NumberMonitor() {
	const { monitorOfficialFilter } = useContext(NumberOfficialMonitorContext);
	const { open, handleOpenModal } = useContext(ModalContext);
	const [modalData, setModalData] = useState({});
	const [modalSettings, setModalSettings] = useState({
		edit: false,
		new: false,
	});
	const [numbers, setNumbers] = useState();
	const [isLoading, setIsLoading] = useState(true);
	const [isFullLoading, setIsFullLoading] = useState(false);
	const [viewAllFilters, setViewAllFilters] = useState(false);
	const [clientsSelect, setClientsSelect] = useState([]);
	const [bots, setBots] = useState([]);
	const [numbersChecks, setNumbersChecks] = useState();
	const [showSaveButton, setShowSaveButton] = useState(false);

	const populateNumber = async (filter) => {
		try {
			if (filter.client) {
				if (Object.keys(filter.client).includes("value")) {
					filter.client = filter.client.value;
				}
			}
			if (filter.sector) {
				if (Object.keys(filter.sector).includes("value")) {
					filter.sector = filter.sector.value;
				}
			}
			// https://b1.cadu.dev.br/monitor/numbers
			const { data } = await authApi.post("/officialNumbers/list", {
				...filter,
			});
			setNumbers(data.numbers);
			let numbersCheckObj = {};
			for (const number of data.numbers) {
				if (number?.isChecked) {
					numbersCheckObj[number._id] = {
						isChecked: number?.isChecked || false,
						noCancel: true,
					};
				}
			}
			setNumbersChecks(numbersCheckObj);
			setIsLoading(false);
		} catch (error) {
			setIsLoading(false);
		}
	};

	const handleAllBots = async () => {
		try {
			const { data } = await authApi.get("/bot-builder/bots");
			setBots(data);
		} catch (error) {}
	};

	const populateSelectAccount = async () => {
		try {
			const { data } = await authApi.get("/account/all/select");
			const seriData = [];
			data.forEach((item) => {
				seriData.push({ label: item.name, value: item._id });
			});
			setClientsSelect(seriData);
		} catch (error) {
			toast.error(
				"Não foi possivel encontrar os dados para filtro",
				TOASTIFY_OPTIONS
			);
		}
	};

	const handleAllFilters = useCallback(() => {
		setViewAllFilters((view) => !view);
	}, []);

	const main = () => {
		populateNumber({
			sector: monitorOfficialFilter.sector.value,
			client: monitorOfficialFilter.client.value,
			number: monitorOfficialFilter.number,
		});
	};

	useEffect(() => {
		main();
		populateSelectAccount();
		handleAllBots();
		// populateSector();
	}, []);

	const handleCheckStamp = (id) => {
		return (e) => {
			setNumbersChecks({
				...numbersChecks,
				edited: true,
				[id]: {
					isChecked: e.target.checked,
					noCancel: numbersChecks[id]?.noCancel,
				},
			});
		};
	};

	const clearCheckStamp = () => {
		let numbersChecksAsObj = numbersChecks;
		for (const item in numbersChecks) {
			if (!numbersChecksAsObj[item].noCancel) {
				Reflect.deleteProperty(numbersChecksAsObj, item);
			} else {
				numbersChecksAsObj[item].isChecked = true;
			}
		}
		setNumbersChecks(numbersChecksAsObj);
		setShowSaveButton(false);
	};

	useEffect(() => {
		if (numbersChecks && numbersChecks.edited) {
			setShowSaveButton(true);
		}
	}, [numbersChecks]);

	const editCheckNumbers = async () => {
		try {
			setIsFullLoading(true);
			await authApi.post("/officialNumbers/edit-check", {
				numbersChecks,
			});
			setShowSaveButton(false);
			await populateNumber({
				sector: monitorOfficialFilter.sector.value,
				client: monitorOfficialFilter.client.value,
				number: monitorOfficialFilter.number,
			});
			setIsFullLoading(false);
		} catch (error) {
			setIsFullLoading(false);
		}
	};

	function handleModal(type, open, data) {
		return () => {
			setModalData(data);
			setModalSettings((e) => {
				const aux = {};
				Object.entries(e).forEach((k, v) => {
					aux[k] = false;
				});
				return {
					...aux,
					[type]: open,
				};
			});
			handleOpenModal();
		};
	}

	return (
		<Page>
			{viewAllFilters && (
				<NumberOfficialMonitorFilter
					populateNumber={populateNumber}
					clientsSelect={clientsSelect}
					handleAllFilters={handleAllFilters}
					className={viewAllFilters ? "show" : "hide"}
					filterType="Números"
				/>
			)}
			{open && modalSettings.link && (
				<LinkBot
					open={open}
					populateTable={populateNumber}
					data={modalData}
					bots={bots}
				/>
			)}
			{isFullLoading ? <Loading /> : null}
			<Sidebar activeMenu="numbersOfficial" />
			<ScreenView>
				{showSaveButton ? (
					<StickyButtonFooter>
						<DefaultButton onClick={clearCheckStamp}>Cancelar</DefaultButton>
						<DefaultButton onClick={editCheckNumbers}>Salvar</DefaultButton>
					</StickyButtonFooter>
				) : null}
				<ContentMain>
					<SubPageMain>
						<Apresentation>
							<span>Monitoramento dos números</span>
						</Apresentation>
						<MyHorizontalScrollView>
							<div>
								<button onClick={handleAllFilters}>
									<VscListFilter style={{ marginRight: 5 }} />
									Todos os filtros
								</button>
							</div>
						</MyHorizontalScrollView>

						{isLoading ? (
							<Skeleton
								data={[
									"Cliente",
									"Setor",
									"Número",
									"Email do número",
									"Limite de Disparo",
									"Desc",
									"Verificado",
								]}
							/>
						) : (
							<>
								{numbers && numbers.length ? (
									<>
										<MyTable responsive>
											<MyTableHead>
												<MyTableTR>
													<th>Cliente</th>
													<th>Setor</th>
													<th>Número</th>
													<th>Email do número</th>
													<th>Limite de disparo</th>
													<th>Desc</th>
													<th>Verificado</th>
													<th>Ações</th>
												</MyTableTR>
											</MyTableHead>
											<MyTableBody>
												{numbers?.map((item) => (
													<MyTableTR key={item._id}>
														<td>{item?.accountName}</td>
														<td>{item?.sectorName}</td>
														<td>{item?.number}</td>
														<td>{item?.numberEmail ?? "-"}</td>
														<td>{item?.dispatchLimit ?? "-"}</td>
														<td>
															{item?.description ? item?.description : "-"}
														</td>
														<td>
															<ContainerCheckbox>
																<input
																	type="checkbox"
																	checked={numbersChecks?.[item._id]?.isChecked}
																	onChange={handleCheckStamp(item._id)}
																/>
																<span className="checkmark"></span>
															</ContainerCheckbox>
														</td>
														<td
															style={{
																display: "flex",
																justifyContent: "center",
															}}
														>
															<MyTooltip label="Associar Bot">
																<DefaultButton
																	onClick={handleModal("link", true, item)}
																>
																	<FaLink size={20} />
																</DefaultButton>
															</MyTooltip>
														</td>
													</MyTableTR>
												))}
											</MyTableBody>
										</MyTable>
									</>
								) : (
									<Error>Nenhum dado encontrado</Error>
								)}
							</>
						)}
					</SubPageMain>
				</ContentMain>
				<Footer />
			</ScreenView>
		</Page>
	);
}

export default NumberMonitor;
